/* eslint-disable @typescript-eslint/no-explicit-any */
export const loadBambuser = (livestreamId: string) => {
  if (!window.initBambuserLiveShopping) {
    window.initBambuserLiveShopping = function (item: any) {
      window.initBambuserLiveShopping.queue.push(item);
    };
    window.initBambuserLiveShopping.queue = [];
    const scriptNode = document.createElement('script');
    scriptNode['src'] = 'https://lcx-embed.bambuser.com/moda-operandi/embed.js';
    document.body.appendChild(scriptNode);
  }

  window.initBambuserLiveShopping({
    showId: livestreamId,
    node: document.getElementById(`liveshopping-${livestreamId}`),
    type: 'overlay'
  });

  window.onBambuserLiveShoppingReady = (player: any) => {
    player.configure({
      buttons: {
        checkout: player.BUTTON.MINIMIZE,
        dismiss: player.BUTTON.MINIMIZE
      },
      floatingPlayer: {
        navigationMode: player.FLOATING_PLAYER_NAVIGATION_MODE.MANUAL
      }
    });
  };
};
